import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import * as pbi from 'powerbi-client';
import { PowerBIService } from '../../reports/powerbiservice.service';
import { Subscription } from 'rxjs';
import { Logger } from '../../shared/logger/logger.component';
import { IEmbedConfigurationBase } from 'embed';
import { ActivatedRoute } from '@angular/router';
import { ReportFilterStateModel } from './reportfilterstate.model';
import { FormControl, FormArray, FormGroup, FormBuilder } from '@angular/forms';
import { MatListOption } from '@angular/material/list';
import { MatOption } from '@angular/material/core';
import { MatRadioChange } from '@angular/material/radio';
import { CustomOktaAuthService } from '../../auth/oktaauth.service';
import { CompareGroupService } from '../../comparegroup/comparegroupservice.service';
import { OrganizationDTO } from '../../comparegroup/organization.dto';
import { CohortOrgDateDTO } from '../../shared/loadreportwithfilters/cohortorgdate.dto';
import { NameValuePair } from './namevaluepair.model';
import { FilterConfigDTO } from './filterConfig.dto';
import { FilterService } from './filterservice.service';
import { CompareGroupDTO } from '../../comparegroup/compare-group.dto';
import { filter } from 'rxjs/operators';
import {MatCardModule} from '@angular/material/card';
import { ISlicerFilter } from 'powerbi-models';


@Component({
    selector: 'app-loadreportwithfilters',
    templateUrl: './loadreportwithfilters.component.html',
    styleUrls: ['./loadreportwithfilters.component.scss'],
    standalone: false
})
export class LoadReportWithFiltersComponent implements OnInit, OnDestroy {

  reportName: string;

  isLoading: boolean;
  isApplyFiltersInProgress = false;
  tokenSubscription: Subscription;
  private authSvcSubscription: Subscription;
  orgIDsSubscription: Subscription;
  filterConfigSubscription: Subscription;
  cohortSubscription: Subscription;
  compareGroupSubscription: Subscription;
  loggedInUserName: string;
  accessToken: string;

  pbiReport: pbi.Report;
  pbiSlicers: pbi.VisualDescriptor[];
  firstPage: pbi.Page;

  currentTabName: string;
  reportState: ReportFilterStateModel;
  form: FormGroup
  showFilterPane = false;
  showAdvancedFilters = false;

  SystemSelected = new FormControl();
  OrgSelected = new FormControl();
  CompareGroupSelected = new FormControl();
  YearSelected = new FormControl();
  CohortSelected = new FormControl();

  AgeSelected = new FormControl();
  DegreeAwardedSelected = new FormControl();
  EthnicitySelected = new FormControl();
  GenderSelected = new FormControl();
  GPASelected = new FormControl();
  PreviousDegreeSelected = new FormControl();
  UnitSelected = new FormControl();
  TerminationReasonSelected = new FormControl();
  EmploymentStatusSelected = new FormControl();//LPNLVNEmploymentStatus
  PreviousHealthCareExperienceSelected = new FormControl();

  sampleFormControl = new FormControl();
  selectedValue: string;
  CompareGroupSelected2 = "";
  allOptionText = 'All';
  allNRPParticipantsText = 'All NRP Participants';
  isFormDirty = false;
  isTerminationReport = false;
  isCFCommentsReport = false;
  is2006Reports = false;
  isPageFilterEnabledForCompareGroup = false;
  showSystemFilter = false;
  DELIMITER = '|';
  isLanding = true;
  isCompareGroupChanged = false;

  customCompareGroupLabelText = 'Benchmark';
  selfCompareGroupLabelText = 'Self Compare Benchmark';
  compareGroupType = '';

  AgeData: Array<any>;
  EthnicityData: Array<any>;
  DegreeAwardedData: Array<any>;
  GenderData: Array<any>;
  GPAData: Array<any>;
  PreviousDegreeData: Array<any>;
  UnitData: Array<any>;
  TerminationReasonData: Array<any>;
  EmploymentStatusData: Array<any>;//LPNLVNEmploymentStatus
  PreviousHealthCareExperienceData: Array<any>

  OrganizationData: Array<NameValuePair>;
  AllOrgs: Array<OrganizationDTO>;
  SystemData: Array<NameValuePair>;
  AllCohorts: Array<CohortOrgDateDTO>;
  YearData: Array<NameValuePair>;
  CohortData: Array<NameValuePair>;
  CompareGroupData: Array<NameValuePair>;
  allCompareGroup: Array<CompareGroupDTO>;
  filterSelections:Array<any>;
  pageTitle: string = '';

  @ViewChild('allSystemSelected') private allSystemSelected: MatOption;

  constructor(private service: PowerBIService, private logger: Logger, private activatedRoute: ActivatedRoute,
    private authSvc: CustomOktaAuthService, private compareGroupService: CompareGroupService, private filterService: FilterService,
    private oktaService: CustomOktaAuthService) {
  }

  private powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory,
    pbi.factories.routerFactory);

  ngOnInit() {
    //this.logger.log('load report ngOnInit');
    //this.isLoading = true;     
    this.oktaService.refreshToken('loadreportwithfilters ngOnInit');

    this.activatedRoute.params.subscribe(
      params => {
        this.isApplyFiltersInProgress = true;
        this.pageTitle = this.getPageTitle(params.reportId);
        this.resetComponent();
        this.reportName = params.reportId;
        if (params.reportId) {
          this.reportName = params.reportId;
        }
        
        console.log('loadreportwithfilters ngOnInit', params.reportId);
        // console.log('loadreportwithfilters ngOnInit', this.reportName);
        // if (this.currentTabName.toLocaleLowerCase().indexOf('reason') > -1) {
        //   this.isTerminationReport = true;
        // }
        if (this.reportName.toLocaleLowerCase().indexOf('caseyfinkcomments') > -1 || this.reportName.toLocaleLowerCase().indexOf('pesurveythoughts') > -1) {
          this.isCFCommentsReport = true;
          this.isPageFilterEnabledForCompareGroup = false;
        }

        if ((this.reportName.toLocaleLowerCase().indexOf('caseyfinkexperience') > -1  && this.reportName.length < 20) || (this.reportName.toLocaleLowerCase().indexOf('caseyfinkcomments') > -1  && this.reportName.length < 19) ||
          (this.reportName.toLocaleLowerCase().indexOf('caseyfinkskills') > -1 && this.reportName.length < 18) || (this.reportName.toLocaleLowerCase().indexOf('caseyfinktransition') > -1 && this.reportName.length < 21)) {

          this.is2006Reports = true;
        }
          else this.is2006Reports = false;
        //temporary fix to enable page filter for compare group
        // var reportGroup = this.getReportGroup(params.reportId);
        // if (reportGroup && reportGroup.toLocaleLowerCase().indexOf('pagefilter') > -1) {
        //   this.isPageFilterEnabledForCompareGroup = true;
        // }
        //console.log(this.reportName);
        //this.loggedInUserName = localStorage.getItem('userId') as string;
        //this.logger.log(`this.loggedInUserName${this.loggedInUserName}`);
        this.reportState = <ReportFilterStateModel>{};
        //console.log('this.AllOrgs', this.AllOrgs);
        if(this.isLanding && !this.AllOrgs)
          this.loadFilters();
        else
        {
          this.isApplyFiltersInProgress = false;
          this.saveStateInLocalStorage();
        }
        if(this.isLanding && this. reportState && this. reportState.CompareGroup && this. reportState.CompareGroup[0] != this.allNRPParticipantsText)
        {
          this.isCompareGroupChanged = true;
        }


        // setTimeout(() => {
        //   this.embedPowerBIReport();
        // }, 0);
      }
    );

  }

  getPageTitle(reportId: string) {
    let reportLinks = JSON.parse(sessionStorage.getItem('reportLinks'));
    if (!reportLinks)
      return reportId;
    let report = reportLinks.find(x => x.tag == reportId);
    if (report)
      return report.displayName;
  }

  getReportGroup(reportId: string) {
    let reportLinks = JSON.parse(sessionStorage.getItem('reportLinks'));
    if (!reportLinks)
      return reportId;
    let report = reportLinks.find(x => x.tag == reportId);
    if (report)
      return report.reportGroup;
  }

  resetComponent() {
    this.pbiReport = null;
    this.pbiSlicers = null;
    this.firstPage = null;
    this.currentTabName = '';
    this.isTerminationReport = false;
    this.isCFCommentsReport = false;
    this.is2006Reports =false;
    this.isLanding = true;
    this.isPageFilterEnabledForCompareGroup = true;
  }
  getTitleString(arr: Array<string>) {
    //console.log(`arr`, arr);df
    if (!arr || arr.length == 0)
      return '';

    var allItems = arr.filter(x => x != this.allOptionText);
    return allItems.join(', ');
  }

  getSelectedString(formControl: FormControl, filtername = null) {
    let str = '';
    var arr = formControl.value as Array<any>;
    if (!arr)
      return str;
    var allSelected = arr.indexOf(this.allOptionText) > -1;

    switch (filtername) {
      case 'System':
        if (allSelected) {
          if (this.SystemData && this.SystemData.length == 1) {
            return this.SystemData[0].name;
          }
          else
            str = this.allOptionText;
        }
        else {
          str = arr[0];
        }
        break;
      case 'Organization':
        if (allSelected) {
          if (this.OrganizationData && this.OrganizationData.length == 1) {
            return this.OrganizationData[0].name;
          }
          else
            str = this.allOptionText;
        }
        else {
          str = arr[0];
        }
        break;
      default:
        break;
    }
    if (allSelected)
      return str;
    if (arr.length != 1)
      str = `${str} (+${arr.length - 1} ${arr.length === 2 ? 'other' : 'others'})`;
    return str;
  }

  getMatCardText(textValue: string[], maxLength: number = 60) {

    //check textValue is null or empty
    if (!textValue || textValue.length == 0)
      return '';
    let text = textValue.join(', ');
    if(!text)
      return '';

    // console.log('text', text);
    // console.log('text', text.length);

    if (text.includes('All'))
      return 'All';
    else if (maxLength == 0)
      return text;
    else if (text.length > maxLength)
      return text.substring(0, maxLength) + '...';
    return text;
  }

  async loadPageState() {
    this.isApplyFiltersInProgress = true;
    this.filterService.GetUserFilterState().subscribe(async response => {
      var rep = sessionStorage.getItem('reportState');
      if (rep) {
        //console.log('session report state: ', rep);
        this.reportState = JSON.parse(rep);
      }
      else {
        this.reportState = <ReportFilterStateModel>{};
        this.reportState.CompareGroup = [this.allNRPParticipantsText];
      }
      if (response) {
        //console.log(`response`, response)
        if(this.isLanding)
        {
          this.reportState.SystemList = response.systemSelected.split(this.DELIMITER);
          this.reportState.OrgNamesList = response.orgSelected.split(this.DELIMITER);
          //console.log(`response.compareGroupSelected.split(',')`, response.compareGroupSelected.split(','));
          this.reportState.CompareGroup = response.compareGroupSelected.split(this.DELIMITER);
          if(this.reportState.CompareGroup[0] != this.allNRPParticipantsText)
            this.isCompareGroupChanged = true;
        }
        //console.log(`this.reportState.CompareGroup`, this.reportState.CompareGroup)
        if (response.isSelfCompareGroup)
          this.reportState.CompareGroupType = this.selfCompareGroupLabelText;
        else
          this.reportState.CompareGroupType = this.customCompareGroupLabelText;
        //selfcomparefix
        this.compareGroupType = this.reportState.CompareGroupType;
      }
      //console.log(`this.reportState after load from DB`, this.reportState)
      this.setInitFilterState(this.SystemSelected, this.reportState.SystemList, this.SystemData);
      await this.setOrganizationFilter(true);

      this.setInitFilterState(this.AgeSelected, this.reportState.AgeList, this.AgeData);
      //LPNLVNEmploymentStatus
      this.setInitFilterState(this.DegreeAwardedSelected, this.reportState.DegreeAwardedList, this.DegreeAwardedData, 'DegreeAwarded');
      this.setInitFilterState(this.EthnicitySelected, this.reportState.EthnicityList, this.EthnicityData);
      this.setInitFilterState(this.GenderSelected, this.reportState.GenderList, this.GenderData);
      this.setInitFilterState(this.GPASelected, this.reportState.GPAList, this.GPAData);
      this.setInitFilterState(this.PreviousDegreeSelected, this.reportState.PreviousDegreeList, this.PreviousDegreeData);
      this.setInitFilterState(this.UnitSelected, this.reportState.UnitList, this.UnitData);
      this.setInitFilterState(this.TerminationReasonSelected, this.reportState.TerminationList, this.TerminationReasonData);
      //LPNLVNEmploymentStatus
      this.setInitFilterState(this.EmploymentStatusSelected, this.reportState.EmploymentStatusList, this.EmploymentStatusData, 'EmploymentStatus');
      this.setInitFilterState(this.PreviousHealthCareExperienceSelected, this.reportState.PreviousHealthCareExperienceList, this.PreviousHealthCareExperienceData, 'PreviousHealthCareExperience');
      if (!rep)
        this.saveStateInLocalStorage();
      //console.log('this.isLanding', this.isLanding);
      setTimeout(() => {
      if(!this.isLanding)
        this.applyAllFilters();
      else
        this.isApplyFiltersInProgress = false;
      }, 0);
    });

  }

  setInitFilterState(formControl: FormControl, currentSelection: Array<any>, allOptions: Array<NameValuePair>, filtername = null) {
    if (!currentSelection || currentSelection.length == 0) {
      console.log('setInitFilterState', filtername)
      switch (filtername) {
        case 'Compare Group':
          //console.log(`formControl`, formControl)
          currentSelection = [this.allNRPParticipantsText];
          //console.log(`currentSelection comparegroup`, currentSelection)
          break;
        //LPNLVNEmploymentStatus
        // case 'EmploymentStatus':
        //   //console.log(`EmploymentStatus formControl`, formControl)
        //   currentSelection = ['Full-time', 'No data provided'];
        //   //console.log(`currentSelection EmploymentStatus`, currentSelection)
        //   break;
        // case 'DegreeAwarded':
        //   //console.log(`DegreeAwarded formControl`, formControl)
        //   //console.log(`allOptions`, allOptions);
        //   var allOptionsExceptLPNLVN = allOptions.filter(x => x.name != 'LPN/LVN');
        //   //console.log(`allOptionsExceptLPNLVN`, allOptionsExceptLPNLVN)
        //   currentSelection = allOptionsExceptLPNLVN.map<string>(d => d.name);
        //   //console.log(`currentSelection DegreeAwarded`, currentSelection)
        //   break;
        default:
          currentSelection = [this.allOptionText];
          if (allOptions && allOptions.length > 0)
            currentSelection.push(...allOptions.map<string>(d => d.name));
          break;
      }

      formControl.patchValue(currentSelection);
      return;
    }
    else {
      //console.log(`else block`, currentSelection);
      if (filtername == 'Compare Group')
        currentSelection = currentSelection[0];
      //console.log(`else block after`, currentSelection);
    }
    formControl.setValue(currentSelection as string[]);

  }

  allSelectedHandler(formControl: FormControl, allData: Array<any>, allSelectedOption: MatOption = null, filterName: string = null) {
    //console.log(`allSelectedOption.selected`, allSelectedOption.selected)
    if (allSelectedOption.selected) {
      var arrValues = allData.map(x => x.name);
      formControl.patchValue([this.allOptionText, ...arrValues]);
    }
    else {
      formControl.patchValue([]);
    }
    this.updateFilters(filterName);
  }

  singleFilterItemSelectedHandler(allData: Array<any>, formControl: FormControl, allSelectedOption: MatOption, filterName: string = null) {
    //console.log(`allSelectedOption`, allSelectedOption);
    if (allSelectedOption.selected) {
      allSelectedOption.deselect();// = false;
    }
    //console.log(`formControl.value`, formControl)
    //console.log(`allData.length`, allData)
    if (formControl.value.length == allData.length)
      allSelectedOption.select();

    if(this.isLanding)
      this.saveStateInLocalStorage();

    //this.setOrganizationFilter();
    this.updateFilters(filterName);
  }
  setYearFilter(defaultState = false) {
    //console.log(`setYearFilter`);
    this.YearData = [];
    this.AllCohorts.forEach(element => {
      if (this.YearData.filter(x => x.name === element.yearHired.toString()).length == 0) {
        var yearobj = { name: element.yearHired.toString(), value: element.yearHired.toString() };
        this.YearData.push(yearobj);
      }
    });

    this.YearData = this.sortNameValuePairData(this.YearData, true);
    if (!defaultState) {
      var arrValues = [this.allOptionText, ...this.YearData.map(x => x.name)];
      this.YearSelected.patchValue(arrValues);
    }
    else
      this.setInitFilterState(this.YearSelected, this.reportState.YearList, this.YearData, 'Year');

    if(this.isLanding)
      this.saveStateInLocalStorage();
    this.setCohortFilter(defaultState);
  }
  setCompareGroupFilter(defaultState = false) {
    if (!defaultState) {
      var arrValues = this.allNRPParticipantsText;
      //arrValues.push(...this.YearData.map(x => x.name));
      this.CompareGroupSelected.patchValue(arrValues);
      this.compareGroupType = this.customCompareGroupLabelText;
      this.fillCompareGroupDropdown();
    }
    else
      this.setInitFilterState(this.CompareGroupSelected, this.reportState.CompareGroup, this.CompareGroupData, 'Compare Group');
    //console.log(`this.CompareGroupSelected`, this.CompareGroupSelected)
  }

  setCohortFilter(defaultState = false) {
    //console.log(`setCohortFilter`);
    //console.log(`this.YearSelected.value`, this.YearSelected.value);
    var cohorts = this.AllCohorts.filter(x => (<Array<any>>this.YearSelected.value).includes(x.yearHired.toString()));
    //console.log(`cohorts`, cohorts)
    this.CohortData = [];
    cohorts.forEach(element => {
      if (this.CohortData.filter(x => x.name === element.cohortDateString.toString()).length == 0)
        this.CohortData.push({ name: element.cohortDateString, value: element.cohortDateString });
    });
    this.CohortData = this.sortDate(this.CohortData);
    if (!defaultState) {
      var arrValues = [this.allOptionText];
      arrValues.push(...this.CohortData.map(x => x.name));
      this.CohortSelected.patchValue(arrValues);
    }
    else
      this.setInitFilterState(this.CohortSelected, this.reportState.CohortDatesList, this.CohortData, 'Cohort');
    if(this.isLanding)
      this.saveStateInLocalStorage();
    //   this.isApplyFiltersInProgress = false;
    //console.log(`setCohortFilter completed`);
  }
  async setOrganizationFilter(defaultState = false) {
    this.isApplyFiltersInProgress=true;
    console.log('setOrganizationFilter defaultState: ', defaultState)
    var orgs = this.AllOrgs;
    if (this.showSystemFilter)
      orgs = this.AllOrgs.filter(x => (<Array<any>>this.SystemSelected.value).includes(x.parentSystem));
    // console.log(`orgs`, orgs)
    this.OrganizationData = [];
    orgs.forEach(element => {
      if (this.OrganizationData.filter(x => x.name === element.orgName).length == 0)
        this.OrganizationData.push({ name: element.orgName, value: element.orgName });
    });
    this.OrganizationData = this.sortNameValuePairData(this.OrganizationData);

    if (!defaultState) {
      var arrValues = [this.allOptionText, ...this.OrganizationData.map(x => x.name)];
      this.OrgSelected.patchValue(arrValues);
    }
    else
      this.setInitFilterState(this.OrgSelected, this.reportState.OrgNamesList, this.OrganizationData, 'Organization');

    await this.getCohortsFromOrg(defaultState);


  }
  updateFilters(filterName: string) {
    switch (filterName) {
      case 'System':
        if(this.reportState.CompareGroup[0] != this.allNRPParticipantsText)
          this.isCompareGroupChanged = true;
        this.setOrganizationFilter();
        break;
      case 'Organization':
        if(this.reportState.CompareGroup[0] != this.allNRPParticipantsText)
          this.isCompareGroupChanged = true;
        this.getCohortsFromOrg();
        break;
      case 'Year':
        this.setCohortFilter();
        break;
      default:
        break;
    }
  }
  allDimSelectedHandler(formControl: FormControl, allData: Array<any>, allSelectedOption: MatListOption = null, filterName: string = null) {
    if (allSelectedOption.selected) {
      //console.log(`formControl`, formControl);
      //console.log(`arr`, allData);
      //console.log(`allSelectedOption`, allSelectedOption.selected)
      var arrValues = allData.map(x => x.name);
      //var arrValues = [this.allOptionText, ...allData];
      //arrValues.push(...allData);
      formControl.patchValue([this.allOptionText, ...arrValues]);
    }
    else {
      formControl.patchValue([]);
    }
    this.isFormDirty = true;
  }
  singleDimFilterItemSelectedHandler(allSelectedOption: MatListOption, filtername) {
    //console.log(`allSelectedOption`, allSelectedOption)
    this.isFormDirty = true;
    if (allSelectedOption.selected) {
      allSelectedOption.selected = false;
      return false;
    }
    //console.log(`filtername`, filtername)
    var allSelect = false;
    switch (filtername) {

      case "Age":
        allSelect = this.AgeSelected.value.length == this.AgeData.length;
        break;
      case "DegreeAwarded":
        allSelect = this.DegreeAwardedSelected.value.length == this.DegreeAwardedData.length;
        break;
      case "Ethnicity":
        allSelect = this.EthnicitySelected.value.length == this.EthnicityData.length;
        break;
      case "Gender":
        allSelect = this.GenderSelected.value.length == this.GenderData.length;
        break;
      case "PreviousDegree":
        allSelect = this.PreviousDegreeSelected.value.length == this.PreviousDegreeData.length;
        break;
      case "GPA":
        allSelect = this.GPASelected.value.length == this.GPAData.length;
        break;
      case "Unit":
        allSelect = this.UnitSelected.value.length == this.UnitData.length;
        break;
      case "TerminationReason":
        allSelect = this.TerminationReasonSelected.value.length == this.TerminationReasonData.length;
        break;
      //LPNLVNEmploymentStatus
      case "EmploymentStatus":
        allSelect = this.EmploymentStatusSelected.value.length == this.EmploymentStatusData.length;
        break;
      case "PreviousHealthCareExperience":
        allSelect = this.PreviousHealthCareExperienceSelected.value.length == this.PreviousHealthCareExperienceData.length;
        break;
      default:
        break;
    }
    allSelectedOption.selected = allSelect;
  }

  IsValidForm(): boolean {
    if (!this.SystemSelected.value || this.SystemSelected.value.length == 0) {
      alert("Please select at least one System");
      return false;
    }
    if (!this.OrgSelected.value || this.OrgSelected.value.length == 0) {
      alert("Please select at least one Organization");
      return false;
    }

    if (!this.YearSelected.value || this.YearSelected.value.length == 0) {
      alert("Please select at least one Year");
      return false;
    }
    if (!this.CohortSelected.value || this.CohortSelected.value.length == 0) {
      alert("Please select at least one Cohort");
      return false;
    }

    if (!this.AgeSelected.value || this.AgeSelected.value.length == 0) {
      alert("Please select at least one Age");
      return false;
    }

    if (!this.DegreeAwardedSelected.value || this.DegreeAwardedSelected.value.length == 0) {
      alert("Please select at least one Degree Awarded");
      return false;
    }

    if (!this.EthnicitySelected.value || this.EthnicitySelected.value.length == 0) {
      alert("Please select at least one Ethnicity");
      return false;
    }

    if (!this.GenderSelected.value || this.GenderSelected.value.length == 0) {
      alert("Please select at least one Gender");
      return false;
    }
    if (!this.GPASelected.value || this.GPASelected.value.length == 0) {
      alert("Please select at least one GPA");
      return false;
    }
    if (!this.PreviousDegreeSelected.value || this.PreviousDegreeSelected.value.length == 0) {
      alert("Please select at least one Previous Degree");
      return false;
    }
    if (!this.UnitSelected.value || this.UnitSelected.value.length == 0) {
      alert("Please select at least one Unit");
      return false;
    }
    if (!this.TerminationReasonSelected.value || this.TerminationReasonSelected.value.length == 0) {
      alert("Please select at least one Termination Reason");
      return false;
    }
    if (!this.CompareGroupSelected.value || this.CompareGroupSelected.value.length == 0) {
      alert("Please select Benchmark");
      return false;
    }
    //LPNLVNEmploymentStatus
    if (!this.EmploymentStatusSelected.value || this.EmploymentStatusSelected.value.length == 0) {
      alert("Please select at least one Employment Status");
      return false;
    }
    if (!this.PreviousHealthCareExperienceSelected.value || this.PreviousHealthCareExperienceSelected.value.length == 0) {
      alert("Please select at least one Previous Health Care Exprerience");
      return false;
    }
    return true;
  }

  async LoadReport() {
    this.isLanding=false;
    this.embedPowerBIReport();
  }
  async onSubmit() {
    this.isLanding=false;
    this.oktaService.refreshToken('loadreportwithfilters onSubmit');
    this.isApplyFiltersInProgress = true;
    var activetab = this.currentTabName;
    if (activetab && this.firstPage && this.firstPage.name != activetab)
      await this.gotoFirstPage();

    if (!this.IsValidForm()) {
      this.isApplyFiltersInProgress = false;
      return;
    }

    this.saveStateInLocalStorage();

    if(this.isLanding)
      this.LoadReport();
    else
    {
      await this.applyAllFilters();
      await this.pbiReport.setPage(activetab);
    }
    this.isFormDirty = false;
    //this.isApplyFiltersInProgress = false;
  }

  closePopup() {


    //alert(this.isFormDirty);
    if (this.isFormDirty == false) {
      this.showAdvancedFilters = false;
      return;
    }
    if (!confirm("There are unsaved changes. Are you sure you want to cancel?")) {
      //this.showAdvancedFilters = false;
      return;
    }
    this.isFormDirty = false;
    this.loadPageState();
    this.showAdvancedFilters = false;
  }

  saveMoreFilters() {
    if(this.isLanding)
      this.saveStateInLocalStorage();
    else
      this.onSubmit();
    //this.closePopup();
    this.showAdvancedFilters = false;
  }

  saveStateInLocalStorage() {
    this.reportState.SystemList = this.SystemSelected.value;//this.form.value.systemArray;
    this.reportState.OrgNamesList = this.OrgSelected.value;//this.form.value.organizationArray;
    if (this.CompareGroupSelected.value)
      this.reportState.CompareGroup = [this.CompareGroupSelected.value];//this.form.value.compareGroupArray;
    this.reportState.CompareGroupType = this.compareGroupType;
    // else
    //   this.reportState.CompareGroup = [this.allNRPParticipantsText];
    this.reportState.YearList = this.YearSelected.value;
    //console.log(`this.reportState.YearList`, this.reportState.YearList);;
    this.reportState.CohortDatesList = this.CohortSelected.value;

    this.reportState.AgeList = this.AgeSelected.value;
    this.reportState.EthnicityList = this.EthnicitySelected.value;//this.form.value.ethnicityArray;
    this.reportState.DegreeAwardedList = this.DegreeAwardedSelected.value; //this.form.value.degreeAwardedArray;
    this.reportState.GenderList = this.GenderSelected.value;
    this.reportState.GPAList = this.GPASelected.value;
    this.reportState.PreviousDegreeList = this.PreviousDegreeSelected.value;
    this.reportState.UnitList = this.UnitSelected.value;
    this.reportState.TerminationList = this.TerminationReasonSelected.value;
    //LPNLVNEmploymentStatus
    this.reportState.EmploymentStatusList = this.EmploymentStatusSelected.value;
    this.reportState.PreviousHealthCareExperienceList = this.PreviousHealthCareExperienceSelected.value;
    sessionStorage.setItem("reportState", JSON.stringify(this.reportState));
    console.log('this.reportState saveStateInLocalStorage', this.reportState);
  }

  async applyFilters() {
    this.isApplyFiltersInProgress = true;
    console.log('applyFilters');
    //await this.setSlicer("Select System");
    await this.setSlicer("Select Focus Org");
    await this.setSlicer("Year");
    await this.setSlicer("CohortDate1");
    //console.log("setfilters main");
    await this.setSlicer("Age");
    await this.setSlicer("Ethnicity");
    await this.setSlicer("Degree Awarded");
    await this.setSlicer("Gender");
    await this.setSlicer("GPA");
    await this.setSlicer("Previous Degree");
    await this.setSlicer("Unit");
    //LPNLVNEmploymentStatus
    await this.setSlicer("EmploymentStatus");
    await this.setSlicer("PreviousHealthCareExperience");
    //console.log(`this.reportName`, this.reportName)
    // if (this.isTerminationReport)
    //   await this.setSlicer("TerminationReason");
    //console.log("setfilters dim");
    if (!this.isCFCommentsReport)
      await this.setSlicer("Select Compare Group");
    else {
      this.reportState.PeriodList = await this.filterService.GetCommentsCountByPeriod(this.reportState.SystemList, this.reportState.OrgNamesList, this.reportState.YearList,
        this.reportState.CohortDatesList, this.reportState.AgeList, this.reportState.DegreeAwardedList, this.reportState.EthnicityList,
        this.reportState.GenderList, this.reportState.GPAList, this.reportState.PreviousDegreeList, this.reportState.UnitList, this.allOptionText, this.DELIMITER, this.reportName)
        .toPromise();
      await this.setSlicer("Period");
    }
    //console.log("setfilters completed");
    //await this.setSlicer("CohortID");
    sessionStorage.setItem("reportState", JSON.stringify(this.reportState));
    // sessionStorage.removeItem('reportState');
    var isCompareGroupFlag = false;
    let compgroupobj: CompareGroupDTO;
    if (this.allCompareGroup)
      compgroupobj = this.allCompareGroup.find(x => x.compareGroupDesc == this.CompareGroupSelected.value);
    if (compgroupobj)
      isCompareGroupFlag = compgroupobj.isSelfCompareGroup;
    this.filterService.SaveUserFilterState(this.reportState.SystemList, this.reportState.OrgNamesList, this.reportState.CompareGroup, '', isCompareGroupFlag, this.DELIMITER)
      .subscribe(response => {
        console.log(`user filter state saved`, response);
      });
    //this.showAdvancedFilters = false;
    this.isApplyFiltersInProgress = false;
    console.log('applyFilters isApplyFiltersInProgress: ', this.isApplyFiltersInProgress);
  }

  async setSlicer(slicerName: string) {
    let slicerVisual = null;
    if (slicerName == "TerminationReason") {
      let pages = await this.pbiReport.getPages();
      let allvisuals = await pages[1].getVisuals();
      slicerVisual = allvisuals.filter(function (visual) {
        return visual.type == "slicer" && visual.title == slicerName;
      })[0];
    }
    else
      slicerVisual = await this.findVisual(slicerName);
    if (!slicerVisual) {
      console.log(`visual not found: `, slicerName);
      return;
    }
    let state = await slicerVisual.getSlicerState();
    //console.log("current slicer state ", state);
    this.createUpdatedSlicerRequestObj(state, slicerName);
    //console.log("after slicer state ", state);j
    await slicerVisual.setSlicerState(state).catch(err => {
      console.log(`slicerName`, slicerName)
      console.log(`err`, err)
      //slicerVisual.setSlicerState(state);
    });
  }
  async resetFilters() {


    // this.reportState.OrgNamesList = [];
    // this.reportState.SystemList = [];
    // this.reportState.YearList = [];
    // this.reportState.CohortDatesList = [];

    this.reportState.AgeList = [];
    this.reportState.DegreeAwardedList = [];
    this.reportState.EthnicityList = [];
    this.reportState.GenderList = [];
    this.reportState.GPAList = [];
    this.reportState.PreviousDegreeList = [];
    this.reportState.UnitList = [];
    this.reportState.TerminationList = [];
    this.reportState.EmploymentStatusList = [];//LPNLVNEmploymentStatus
    this.reportState.PreviousHealthCareExperienceList = [];
    this.reportState.CompareGroup = [this.allNRPParticipantsText];
    this.filterSelections = [];

    this.AgeSelected.patchValue(this.reportState.AgeList);
    this.DegreeAwardedSelected.patchValue(this.reportState.DegreeAwardedList);
    this.EthnicitySelected.patchValue(this.reportState.EthnicityList);
    this.GenderSelected.patchValue(this.reportState.GenderList);
    this.GPASelected.patchValue(this.reportState.GPAList);
    this.PreviousDegreeSelected.patchValue(this.reportState.PreviousDegreeList);
    this.UnitSelected.patchValue(this.reportState.UnitList);
    this.TerminationReasonSelected.patchValue(this.reportState.TerminationList);
    this.CompareGroupSelected.patchValue(this.reportState.CompareGroup);
    //LPNLVNEmploymentStatus
    this.EmploymentStatusSelected.patchValue(this.reportState.EmploymentStatusList);
    this.PreviousHealthCareExperienceSelected.patchValue(this.reportState.PreviousHealthCareExperienceList);

    this.setInitFilterState(this.AgeSelected, this.reportState.AgeList, this.AgeData);
    this.setInitFilterState(this.DegreeAwardedSelected, this.reportState.DegreeAwardedList, this.DegreeAwardedData);
    this.setInitFilterState(this.EthnicitySelected, this.reportState.EthnicityList, this.EthnicityData);
    this.setInitFilterState(this.GenderSelected, this.reportState.GenderList, this.GenderData);
    this.setInitFilterState(this.GPASelected, this.reportState.GPAList, this.GPAData);
    this.setInitFilterState(this.PreviousDegreeSelected, this.reportState.PreviousDegreeList, this.PreviousDegreeData);
    this.setInitFilterState(this.UnitSelected, this.reportState.UnitList, this.UnitData);
    this.setInitFilterState(this.TerminationReasonSelected, this.reportState.TerminationList, this.TerminationReasonData);
    this.setInitFilterState(this.CompareGroupSelected, this.reportState.CompareGroup, this.CompareGroupData, "Compare Group");
    //LPNLVNEmploymentStatus
    this.setInitFilterState(this.EmploymentStatusSelected, this.reportState.EmploymentStatusList, this.EmploymentStatusData);
    this.setInitFilterState(this.PreviousHealthCareExperienceSelected, this.reportState.PreviousHealthCareExperienceList, this.PreviousHealthCareExperienceData);

    // this.isApplyFiltersInProgress = true;
    // var activetab = this.currentTabName;
    // if (this.firstPage.name != activetab)
    //   await this.gotoFirstPage();

    // await this.applyAllFilters();
    // await this.pbiReport.setPage(activetab);
    this.isFormDirty = false;
    //this.isApplyFiltersInProgress = false;
    // let bookmarks = await this.pbiReport.bookmarksManager.getBookmarks();

    // let resetBookmark = bookmarks.filter(x => x.displayName == "ResetFilter");
    // let closeBookmark = bookmarks.filter(x => x.displayName == "Close Filter");

    // await this.pbiReport.bookmarksManager.apply(resetBookmark[0].name);
    // await this.pbiReport.bookmarksManager.apply(closeBookmark[0].name);

    // localStorage.setItem("reportState", JSON.stringify(this.reportState));
  }
  createUpdatedSlicerRequestObj(state: pbi.models.ISlicerState, slicerName: string) {

    var slicerTarget = null, slicerValues = null, allSelected = false;
    switch (slicerName.toUpperCase()) {
      case "SELECT SYSTEM":
        slicerValues = this.reportState.SystemList;
        allSelected = (this.reportState.SystemList as Array<string>).indexOf(this.allOptionText) > -1;
        slicerTarget = {
          table: "Organizations",
          column: "ParentSystem"
        };
        break;
      case "SELECT FOCUS ORG":
        slicerValues = this.reportState.OrgNamesList;
        //allSelected = (this.reportState.OrgNamesList as Array<string>).indexOf(this.allOptionText) > -1;
        slicerTarget = {
          table: "Organizations",
          column: "OrgName"
        };
        break;
      case "YEAR":
        //slicerValues = this.reportState.YearList;

        if (this.reportState.YearList) {
          //allSelected = (this.reportState.YearList as Array<string>).indexOf(this.allOptionText) > -1;
          slicerValues = <Array<number>>this.reportState.YearList.map(item => {
            if (item != this.allOptionText)
              return parseInt(item, 10);
          }).filter(x => !isNaN(x));

          if (!((this.reportState.CohortDatesList as Array<string>).indexOf(this.allOptionText) > -1) && this.AllCohorts) {
            allSelected = false;
            //slicerValues = Array<number>[];
            slicerValues = [];
            //console.log(`this.AllCohorts`, this.AllCohorts)
            var years = this.AllCohorts.filter(x => (<Array<any>>this.reportState.CohortDatesList).includes(x.cohortDateString.toString()));
            years.forEach(item => {
              if (slicerValues.filter(x => x == item.yearHired).length == 0)
                slicerValues.push(item.yearHired);
            });
            //console.log(slicerValues);
          }
        }
        else {
          if (this.AllCohorts) {
            slicerValues = [];
            this.AllCohorts.forEach(element => {
              if (slicerValues.filter(x => x == element.yearHired.toString()).length == 0) {
                slicerValues.push(element.yearHired);
              }
            })
          }
        }
        //selfcomparefix
        if (this.reportState.CompareGroupType == this.selfCompareGroupLabelText) {
          if (slicerValues && slicerValues.filter(x => x == 1971).length == 0) {
            slicerValues.push(1971);
          }
        }
        else {
          if (slicerValues && slicerValues.filter(x => x == 1971).length > 0) {
            slicerValues = slicerValues.filter(x => x != 1971);
          }
        }
        slicerTarget = {
          table: "DIM_CohortOrgDates",
          column: "YearHired"
        };
        break;

      case "COHORTDATE1":
        //slicerValues = this.reportState.CohortDatesList;

        if (this.reportState.CohortDatesList) {
          allSelected = (this.reportState.CohortDatesList as Array<string>).indexOf(this.allOptionText) > -1;
          slicerValues = <Array<string>>this.reportState.CohortDatesList.map(function (item) {
            // return new Date(item).to();
            var date = new Date(item);
            if (!date)
              return;
            var year = date.getFullYear();

            var month = (1 + date.getMonth()).toString();
            //month = month.length > 1 ? month : '0' + month;

            var day = date.getDate().toString();
            //day = day.length > 1 ? day : '0' + day;

            return month + '/' + day + '/' + year;
          });
          //console.log(`this.reportState.CohortDatesList`, this.reportState.CohortDatesList);
          //selfcomparefix
          if (this.reportState.CompareGroupType == this.selfCompareGroupLabelText) {
            if (slicerValues && slicerValues.filter(x => x == '1/1/1971').length == 0) {
              slicerValues.push('1/1/1971');
            }
          }
          else {
            if (slicerValues && slicerValues.filter(x => x == '1/1/1971').length > 0) {
              slicerValues = slicerValues.filter(x => x != '1/1/1971');
            }
          }
        }

        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_CohortOrgDates",
          column: "dCohortDates"
        };
        break;
      case "SELECT COMPARE GROUP":
        //console.log(`this.reportState.CompareGroup`, this.reportState.CompareGroup)
        if (this.reportState.CompareGroup) {
          slicerValues = [...this.reportState.CompareGroup];
          //console.log(`comparegroup`, slicerValues);
        }
        slicerTarget = {
          table: "Benchmarks",
          column: "BenchmarkName"
        };
        break;
      case "AGE":
        slicerValues = this.reportState.AgeList;
        allSelected = (this.reportState.AgeList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_Age",
          column: "dAge"
        };
        break;
      case "ETHNICITY":
        slicerValues = this.reportState.EthnicityList;
        allSelected = (this.reportState.EthnicityList as Array<string>).indexOf(this.allOptionText) > -1;
        slicerTarget = {
          table: "DIM_Ethnicity",
          column: "dEthnicity"
        };
        break;
      case "DEGREE AWARDED":
        slicerValues = this.reportState.DegreeAwardedList;
        allSelected = (this.reportState.DegreeAwardedList as Array<string>).indexOf(this.allOptionText) > -1;
        slicerTarget = {
          table: "DIM_DegreeAwarded",
          column: "dDegreeAwarded"
        };
        break;
      case "GENDER":
        slicerValues = this.reportState.GenderList;
        allSelected = (this.reportState.GenderList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_Gender",
          column: "dGender"
        };
        break;
      case "GPA":
        slicerValues = this.reportState.GPAList;
        allSelected = (this.reportState.GPAList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_GPA",
          column: "dGPA"
        };
        break;
      case "PREVIOUS DEGREE":
        slicerValues = this.reportState.PreviousDegreeList;
        allSelected = (this.reportState.PreviousDegreeList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_PreviousDegree",
          column: "dPreviousDegree"
        };
        break;
      case "UNIT":
        slicerValues = this.reportState.UnitList;
        allSelected = (this.reportState.UnitList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_UnitType",
          column: "dUnitType"
        };
        break;
      case "TERMINATIONREASON":
        slicerValues = this.reportState.TerminationList;
        allSelected = (this.reportState.TerminationList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_TerminationReason",
          column: "dTerminationReason"
        };
        break;
      case "PERIOD":
        slicerValues = this.reportState.PeriodList;
        //allSelected = (this.reportState.OrgNamesList as Array<string>).indexOf(this.allOptionText) > -1;
        slicerTarget = {
          table: "DIM_Period",
          column: "dPeriod"
        };
        break;
      //LPNLVNEmploymentStatus
      case "EMPLOYMENTSTATUS":
        slicerValues = this.reportState.EmploymentStatusList;
        allSelected = (this.reportState.EmploymentStatusList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_EmploymentStatus",
          column: "dEmploymentStatus"
        };
        break;
      case "PREVIOUSHEALTHCAREEXPERIENCE":
        slicerValues = this.reportState.PreviousHealthCareExperienceList;
        allSelected = (this.reportState.PreviousHealthCareExperienceList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_PreviousHealthCareExperience",
          column: "PreviousHealthCareExperience"
        };
        break;
    }
    if (!slicerValues || slicerValues.length == 0 || allSelected) {
      state.filters = [];
      return;
    }
    console.log('createUpdatedSlicerRequestObj slicer values', slicerValues);
    state.filters = [{
      $schema: "http://powerbi.com/product/schema#basic",
      target: slicerTarget,
      operator: "In",
      values: [...slicerValues],
      filterType: pbi.models.FilterType.Basic,
      //requireSingleSelection: true
    }];

  }

  buildSlicerRequestObjList(slicerName: string): pbi.models.IBasicFilter {

    var slicerTarget = null, slicerValues = null, allSelected = false;
    switch (slicerName.toUpperCase()) {
      case "SELECT SYSTEM":
        slicerValues = this.reportState.SystemList;
        allSelected = (this.reportState.SystemList as Array<string>).indexOf(this.allOptionText) > -1;
        slicerTarget = {
          table: "Organizations",
          column: "ParentSystem"
        };
        break;
      case "SELECT FOCUS ORG":
        slicerValues = this.reportState.OrgNamesList;
        //allSelected = (this.reportState.OrgNamesList as Array<string>).indexOf(this.allOptionText) > -1;
        slicerTarget = {
          table: "Organizations",
          column: "OrgName"
        };
        break;
      case "YEAR":
        //slicerValues = this.reportState.YearList;

        if (this.reportState.YearList) {
          //allSelected = (this.reportState.YearList as Array<string>).indexOf(this.allOptionText) > -1;
          slicerValues = <Array<number>>this.reportState.YearList.map(item => {
            if (item != this.allOptionText)
              return parseInt(item, 10);
          }).filter(x => !isNaN(x));

          if (!((this.reportState.CohortDatesList as Array<string>).indexOf(this.allOptionText) > -1) && this.AllCohorts) {
            allSelected = false;
            //slicerValues = Array<number>[];
            slicerValues = [];
            //console.log(`this.AllCohorts`, this.AllCohorts)
            var years = this.AllCohorts.filter(x => (<Array<any>>this.reportState.CohortDatesList).includes(x.cohortDateString.toString()));
            years.forEach(item => {
              if (slicerValues.filter(x => x == item.yearHired).length == 0)
                slicerValues.push(item.yearHired);
            });
            //console.log(slicerValues);
          }
        }
        else {
          if (this.AllCohorts) {
            slicerValues = [];
            this.AllCohorts.forEach(element => {
              if (slicerValues.filter(x => x == element.yearHired.toString()).length == 0) {
                slicerValues.push(element.yearHired);
              }
            })
          }
        }
        //selfcomparefix
        if (this.reportState.CompareGroupType == this.selfCompareGroupLabelText) {
          if (slicerValues && slicerValues.filter(x => x == 1971).length == 0) {
            slicerValues.push(1971);
          }
        }
        else {
          if (slicerValues && slicerValues.filter(x => x == 1971).length > 0) {
            slicerValues = slicerValues.filter(x => x != 1971);
          }
        }
        slicerTarget = {
          table: "DIM_CohortOrgDates",
          column: "YearHired"
        };
        break;

      case "COHORTDATE1":
        //slicerValues = this.reportState.CohortDatesList;

        if (this.reportState.CohortDatesList) {
          allSelected = (this.reportState.CohortDatesList as Array<string>).indexOf(this.allOptionText) > -1;
          slicerValues = <Array<string>>this.reportState.CohortDatesList.map(function (item) {
            // return new Date(item).to();
            var date = new Date(item);
            if (!date)
              return;
            var year = date.getFullYear();

            var month = (1 + date.getMonth()).toString();
            //month = month.length > 1 ? month : '0' + month;

            var day = date.getDate().toString();
            //day = day.length > 1 ? day : '0' + day;

            return month + '/' + day + '/' + year;
          });
          //console.log(`this.reportState.CohortDatesList`, this.reportState.CohortDatesList);
          //selfcomparefix
          if (this.reportState.CompareGroupType == this.selfCompareGroupLabelText) {
            if (slicerValues && slicerValues.filter(x => x == '1/1/1971').length == 0) {
              slicerValues.push('1/1/1971');
            }
          }
          else {
            if (slicerValues && slicerValues.filter(x => x == '1/1/1971').length > 0) {
              slicerValues = slicerValues.filter(x => x != '1/1/1971');
            }
          }
        }

        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_CohortOrgDates",
          column: "dCohortDates"
        };
        break;
      case "SELECT COMPARE GROUP":
        //console.log(`this.reportState.CompareGroup`, this.reportState.CompareGroup)
        if (this.reportState.CompareGroup) {
          slicerValues = [...this.reportState.CompareGroup];
          //console.log(`comparegroup`, slicerValues);
        }
        slicerTarget = {
          table: "Benchmarks",
          column: "BenchmarkName"
        };
        break;
      case "AGE":
        slicerValues = this.reportState.AgeList;
        if(!slicerValues || slicerValues.length == 0)
          break;
        allSelected = (this.reportState.AgeList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_Age",
          column: "dAge"
        };
        break;
      case "ETHNICITY":
        slicerValues = this.reportState.EthnicityList;
        if(!slicerValues || slicerValues.length == 0)
          break;
        allSelected = (this.reportState.EthnicityList as Array<string>).indexOf(this.allOptionText) > -1;
        slicerTarget = {
          table: "DIM_Ethnicity",
          column: "dEthnicity"
        };
        break;
      case "DEGREE AWARDED":
        slicerValues = this.reportState.DegreeAwardedList;
        if(!slicerValues || slicerValues.length == 0)
          break;
        allSelected = (this.reportState.DegreeAwardedList as Array<string>).indexOf(this.allOptionText) > -1;
        slicerTarget = {
          table: "DIM_DegreeAwarded",
          column: "dDegreeAwarded"
        };
        break;
      case "GENDER":
        slicerValues = this.reportState.GenderList;
        if(!slicerValues || slicerValues.length == 0)
          break;
        allSelected = (this.reportState.GenderList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_Gender",
          column: "dGender"
        };
        break;
      case "GPA":
        slicerValues = this.reportState.GPAList;
        if(!slicerValues || slicerValues.length == 0)
          break;
        allSelected = (this.reportState.GPAList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_GPA",
          column: "dGPA"
        };
        break;
      case "PREVIOUS DEGREE":
        slicerValues = this.reportState.PreviousDegreeList;
        if(!slicerValues || slicerValues.length == 0)
          break;
        allSelected = (this.reportState.PreviousDegreeList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_PreviousDegree",
          column: "dPreviousDegree"
        };
        break;
      case "UNIT":
        slicerValues = this.reportState.UnitList;
        if(!slicerValues || slicerValues.length == 0)
          break;
        allSelected = (this.reportState.UnitList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_UnitType",
          column: "dUnitType"
        };
        break;
      case "TERMINATIONREASON":
        slicerValues = this.reportState.TerminationList;
        if(!slicerValues || slicerValues.length == 0)
          break;
        allSelected = (this.reportState.TerminationList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_TerminationReason",
          column: "dTerminationReason"
        };
        break;
      case "PERIOD":
        slicerValues = this.reportState.PeriodList;
        //allSelected = (this.reportState.OrgNamesList as Array<string>).indexOf(this.allOptionText) > -1;
        slicerTarget = {
          table: "DIM_Period",
          column: "dPeriod"
        };
        break;
      //LPNLVNEmploymentStatus
      case "EMPLOYMENTSTATUS":
        slicerValues = this.reportState.EmploymentStatusList;
        if(!slicerValues || slicerValues.length == 0)
          break;
        allSelected = (this.reportState.EmploymentStatusList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_EmploymentStatus",
          column: "dEmploymentStatus"
        };
        break;
      case "PREVIOUSHEALTHCAREEXPERIENCE":
        slicerValues = this.reportState.PreviousHealthCareExperienceList;
        if(!slicerValues || slicerValues.length == 0)
          break;
        allSelected = (this.reportState.PreviousHealthCareExperienceList as Array<string>).indexOf(this.allOptionText) > -1;
        //console.log(slicerValues);
        slicerTarget = {
          table: "DIM_PreviousHealthCareExperience",
          column: "PreviousHealthCareExperience"
        };
        break;
    }
    if (!slicerValues || slicerValues.length == 0 || allSelected) {
      //state.filters = [];
      return;
    }
    console.log('createUpdatedSlicerRequestObj slicer values', slicerValues);
    
    var filterObj: ISlicerFilter = {
      $schema: "http://powerbi.com/product/schema#basic",
      target: slicerTarget,
      operator: "In",
      values: [...slicerValues],
      filterType: pbi.models.FilterType.Basic,
      //requireSingleSelection: true
    };
    this.filterSelections.push(filterObj);
  }

  async findVisual(visualTitle, visualType = "slicer") {
    if (!this.pbiSlicers) {
      if (!this.firstPage) {
        let pages = await this.pbiReport.getPages();
        let log = "Report pages:";
        if (!pages)
          return;
        //console.log(pages);
        this.firstPage = pages[0];
      }
      let allvisuals = await this.firstPage.getVisuals();
      this.pbiSlicers = allvisuals.filter(function (visual) {
        return visual.type == visualType;
      });
      //console.log(this.pbiSlicers);
    }

    var visual = this.pbiSlicers.filter(function (visual) {
      //return visual.type.indexOf(visualType)>0 && visual.title == visualName;
      return visual.title == visualTitle;
    })[0];
    return visual;
  }
  openFullscreen() {
    this.pbiReport.fullscreen();
  }

  embedPowerBIReport() {

    this.tokenSubscription = this.service.getReportEmbedToken(this.reportName)
      .subscribe((response) => {
        console.log('getReportEmbedToken response');
        this.isLoading = false;
        const config = <IEmbedConfigurationBase><any>{
          type: 'report',
          tokenType: pbi.models.TokenType.Embed,
          embedUrl: response.embedUrl,
          accessToken: response.accessToken,
          settings: {
            filterPaneEnabled: false,
            //layoutType: pbi.models.LayoutType.MobilePortrait,
            // customLayout: {
            //   pageSize: {
            //     type: pbi.models.PageSizeType.Custom,
            //     width: window.screen.availWidth
            //   }
            // }
          }
          //slicers: slicers1
        };

        // Grab the reference to the div HTML element that will host the report.
        const reportsContainer = document.getElementById('embedReport') as HTMLElement;

        const report = this.powerbi.embed(
          reportsContainer,
          config
        );


        // Report.off removes a given event handler if it exists.
        report.off('loaded');

        // Report.on will add an event handler which prints to Log window.
        report.on('loaded', (event) => {
          console.log('report loaded: ' + event);
          // this.setTokenExpirationListener(Token.expiration,
          //   2 /*minutes before expiration*/);
          this.pbiReport = <pbi.Report>report;
          //reportPages = await report.getPages();
          //console.log(`this.OrgSelected : loaded`, this.OrgSelected.value);
          this.loadPageState();
          
        });

        report.off('pageChanged');
        report.on('pageChanged', (e: any) => {
          //console.log("event", e);
          const page = e.detail.newPage as pbi.Page;
          //console.log(page.displayName);
          this.currentTabName = page.name;
          this.isTerminationReport = page.displayName.toLocaleLowerCase().indexOf('reason') > -1;
          if (this.isTerminationReport) {
            this.setSlicer("TerminationReason");
          }
        });

        report.on('error', (event) => {
          this.logger.log(event.detail);
          report.off('error');
        });
      },
        (error) => {
          this.logger.log(error);
        });
  }
  async applyAllFilters() {
    //filterSelections.push(this.getSlicerRequestObj("Select System"));

    this.isApplyFiltersInProgress = true;
    console.log('applyAllFilters');
    this.filterSelections = [];
    //await this.setSlicer("Select System");
    this.buildSlicerRequestObjList("Select Focus Org");
    this.buildSlicerRequestObjList("Year");
    this.buildSlicerRequestObjList("CohortDate1");
    //console.log("setfilters main");
    this.buildSlicerRequestObjList("Age");
    this.buildSlicerRequestObjList("Ethnicity");
    this.buildSlicerRequestObjList("Degree Awarded");
    this.buildSlicerRequestObjList("Gender");
    this.buildSlicerRequestObjList("GPA");
    this.buildSlicerRequestObjList("Previous Degree");
    this.buildSlicerRequestObjList("Unit");
    //LPNLVNEmploymentStatus
    this.buildSlicerRequestObjList("EmploymentStatus");
    this.buildSlicerRequestObjList("PreviousHealthCareExperience");
    if (this.isPageFilterEnabledForCompareGroup){
      this.buildSlicerRequestObjList("Select Compare Group");
    }
    else if (this.isCFCommentsReport) {
      this.reportState.PeriodList = await this.filterService.GetCommentsCountByPeriod(this.reportState.SystemList, this.reportState.OrgNamesList, this.reportState.YearList,
        this.reportState.CohortDatesList, this.reportState.AgeList, this.reportState.DegreeAwardedList, this.reportState.EthnicityList,
        this.reportState.GenderList, this.reportState.GPAList, this.reportState.PreviousDegreeList, this.reportState.UnitList, this.allOptionText, this.DELIMITER, this.reportName)
        .toPromise();
        this.buildSlicerRequestObjList("Period");
    }
    console.log("setfilters completed ", this.filterSelections);
    await this.pbiReport.setFilters(this.filterSelections);

    var compareGroupChanged = this.shouldCompareGroupSlicerBeApplied();
    console.log('applyAllFilters compareGroupChanged: ', compareGroupChanged);
    if (compareGroupChanged)
    {
      console.log('applyAllFilters setSlicer Select Compare Group');
      await this.setSlicer("Select Compare Group");
      this.isCompareGroupChanged = false;
    }
    //console.log("setfilters completed");
    //await this.setSlicer("CohortID");
    sessionStorage.setItem("reportState", JSON.stringify(this.reportState));
    // sessionStorage.removeItem('reportState');
    var isCompareGroupFlag = false;
    let compgroupobj: CompareGroupDTO;
    if (this.allCompareGroup)
      compgroupobj = this.allCompareGroup.find(x => x.compareGroupDesc == this.CompareGroupSelected.value);
    if (compgroupobj)
      isCompareGroupFlag = compgroupobj.isSelfCompareGroup;
    this.filterService.SaveUserFilterState(this.reportState.SystemList, this.reportState.OrgNamesList, this.reportState.CompareGroup, '', isCompareGroupFlag, this.DELIMITER)
      .subscribe(response => {
        console.log(`user filter state saved`, response);
      });
    //this.showAdvancedFilters = false;
    this.isApplyFiltersInProgress = false;
    console.log('applyFilters isApplyFiltersInProgress: ', this.isApplyFiltersInProgress);
    
  }
  shouldCompareGroupSlicerBeApplied() {
    var flag = false;
    console.log('shouldCompareGroupSlicerBeApplied');
    console.log('this.isCompareGroupChanged', this.isCompareGroupChanged);
    console.log('this.isCFCommentsReport', this.isCFCommentsReport);
    console.log('this.reportState.CompareGroup', this.reportState.CompareGroup);
    if(this.isCFCommentsReport || this.isPageFilterEnabledForCompareGroup) //when comments report is selected
    {
      flag = false;
    }
    else if (this.isCompareGroupChanged) //when compare group is changed from dropdown
    {
      console.log('this.isCompareGroupChanged');
      flag = true;
    }
    else if (this.isCompareGroupChanged && this.reportState.CompareGroup[0] != this.allNRPParticipantsText) 
    {
      console.log('this.reportState.CompareGroup[0] != this.allNRPParticipantsText');
      flag = true;
    }
    console.log('test 3');
    return flag;
  }
  setAllFilters() {
    var filterSelections: ISlicerFilter[] = [];
    //filterSelections.push(this.getSlicerRequestObj("Select System"));

    filterSelections.push({
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "DIM_DegreeAwarded",
        column: "dDegreeAwarded"
      },
      operator: "In",
      values: ["Accelerated BSN", "ADN", "BS", "Diploma", "BSN","BA in Nursing","Masters","MSN (CNL)", "No data provided","Other"],
      filterType: pbi.models.FilterType.Basic
    });
    //ethnicity
    filterSelections.push({
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "DIM_Ethnicity",
        column: "dEthnicity"
      },
      operator: "In",
      values: ["African American", "Asian", "American Indian or Native Alaskan"],
      filterType: pbi.models.FilterType.Basic
    });
    //Gender
    filterSelections.push({
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "DIM_Gender",
        column: "dGender"
      },
      operator: "In",
      values: ["Female"],
      filterType: pbi.models.FilterType.Basic
    });
    filterSelections.push({
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "DIM_GPA",
        column: "dGPA"
      },
      operator: "In",
      values: ["2.0 - 2.49", "3.0 - 3.49", "2.5 - 2.99","No data provided"],
      filterType: pbi.models.FilterType.Basic
    });
    filterSelections.push({
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "DIM_EmploymentStatus",
        column: "dEmploymentStatus"
      },
      operator: "In",
      values: ["Full-time", "No data provided"],
      filterType: pbi.models.FilterType.Basic
    });
    
    this.pbiReport.setFilters(filterSelections);
  }

  compareGroupTypeOnChange($event: MatRadioChange) {
    this.isCompareGroupChanged = true;
    this.fillCompareGroupDropdown();
  }

  compareGroupOnChange($event: any) {
    console.log('compareGroupOnChange', $event);
    this.isCompareGroupChanged = true;
    if (this.isLanding)
      this.saveStateInLocalStorage();
  }

  ngOnDestroy(): void {
    if (this.tokenSubscription) {
      this.tokenSubscription.unsubscribe();
    }
    if (this.authSvcSubscription) {
      this.authSvcSubscription.unsubscribe();
    }
    if (this.orgIDsSubscription) {
      this.orgIDsSubscription.unsubscribe();
    }
    if (this.cohortSubscription) {
      this.cohortSubscription.unsubscribe();
    }
    if (this.filterConfigSubscription) {
      this.filterConfigSubscription.unsubscribe();
    }
    if (this.compareGroupSubscription) {
      this.compareGroupSubscription.unsubscribe();
    }
  }

  getSystemAndOrgsList() {
    this.orgIDsSubscription = this.filterService.getSystemAndOrgsFromEmailForFilter()
      .subscribe((response: OrganizationDTO[]) => {
        console.log('getSystemAndOrgsList response:', response);
        if (response) {
          this.AllOrgs = [...response];
          //for test
          // this.AllOrgs = this.AllOrgs.filter(x => x.parentSystem.indexOf('Baylor') > -1);
          // this.AllOrgs = this.AllOrgs.filter(x => x.orgName.indexOf('Denton') > -1);
          this.SystemData = [];
          //this.SystemData = [...new Set(this.AllOrgs.map(item => item.parentSystem))];//this.AllOrgs.map(x=>x.parentSystem)
          this.AllOrgs.forEach(element => {
            if (this.SystemData.filter(x => x.name === element.parentSystem).length == 0) {
              var systemObj = { name: element.parentSystem, value: element.parentSystem };
              this.SystemData.push(systemObj);
            }
            if (element.parentSystem != element.orgName)
              this.showSystemFilter = true;
          });
          this.SystemData = this.sortNameValuePairData(this.SystemData);
          //console.log(`this.SystemData`, this.SystemData)
        }

      });
  }

  async getCohortsFromOrg(defaultState = false) {
    var orgs = this.OrgSelected.value as Array<string>;
    console.log('getCohortsFromOrg defaultState:', defaultState)
    this.CohortSelected.disable();
    var orgString = '';
    if (orgs && orgs.length > 0) {
      var selectedOrgIds = [];
      var selectedOrgNames = orgs.filter(x => x != this.allOptionText);
      selectedOrgNames.forEach(element => {
        this.AllOrgs.find(x => x.orgName == element);
      });
      this.AllOrgs.forEach(x => {
        if (selectedOrgNames.includes(x.orgName))
          selectedOrgIds.push(x.orgId);
      });
      orgString = selectedOrgIds.join(',');
    }
    else {
      // orgString = this.AllOrgs.map(x => x.orgId).join(',');
    }
    console.log('getCohortsFromOrg orgstring: ', orgString);
    if (!orgString)
      return;

    let response = await this.filterService.getCohortsFromOrg(orgString).toPromise();
    console.log('getCohortsFromOrg response:', response);
    this.AllCohorts = [...response];
    let test = response.map(x => x.cohortDateString);
    this.setYearFilter(defaultState);
    this.CohortSelected.enable();

    let response2 = await this.filterService.GetCompareGroupsFromOrg(orgString).toPromise();
    this.allCompareGroup = [...response2];
    console.log('compareGroupSubscription response: ', response);
    this.fillCompareGroupDropdown();
    this.setCompareGroupFilter(defaultState);

    this.isApplyFiltersInProgress=false;
    
    if(this.isLanding)
      this.saveStateInLocalStorage();

    return response && response2;

  }

  fillCompareGroupDropdown() {
    let filteredList = [] as CompareGroupDTO[];
    if (this.compareGroupType === this.customCompareGroupLabelText) {
      filteredList = this.allCompareGroup.filter(x => x.isSelfCompareGroup == false) as CompareGroupDTO[];
    }
    else {
      filteredList = this.allCompareGroup.filter(x => x.isSelfCompareGroup == true) as CompareGroupDTO[];
    }
    this.CompareGroupData = [];
    filteredList.forEach(element => {
      if (this.CompareGroupData.filter(x => x.name.toLowerCase().trim() === element.compareGroupDesc.toLowerCase().trim()).length == 0) {
        this.CompareGroupData.push({ name: element.compareGroupDesc, value: element.compareGroupDesc });
      }
    });
    if (this.compareGroupType === this.customCompareGroupLabelText) {
      var comparegroups = this.sortNameValuePairData(this.CompareGroupData);
      var allNRPOption = comparegroups.filter(x => x.name === this.allNRPParticipantsText);
      var otherOptions = comparegroups.filter(x => x.name != this.allNRPParticipantsText);
      this.CompareGroupData = [...allNRPOption, ...otherOptions];
    }

    if (this.CompareGroupData && this.CompareGroupData.length > 0)
      this.CompareGroupSelected.patchValue(this.CompareGroupData[0].name);
    else
      this.CompareGroupSelected.patchValue(null);
  }

  getFilterConfigData() {
    this.orgIDsSubscription = this.filterService.getFilterConfigData()
      .subscribe((response: FilterConfigDTO) => {
        console.log('getFilterConfigData response:', response);
        if (response) {
          // this.EthnicityData = this.sortNameValuePairData(response.ethnicityData);
          // this.DegreeAwardedData = this.sortNameValuePairData(response.degreeAwardedData);
          // this.AgeData = this.sortNameValuePairData(response.ageData);
          // this.GenderData = this.sortNameValuePairData(response.genderData);
          // this.GPAData = this.sortNameValuePairData(response.gpaData);
          // this.PreviousDegreeData = this.sortNameValuePairData(response.previousDegreeData);
          // this.UnitData = this.sortNameValuePairData(response.unitData);
          // this.TerminationReasonData = this.sortNameValuePairData(response.terminationReasonData);
          // //LPNLVNEmploymentStatus
          // this.EmploymentStatusData = this.sortNameValuePairData(response.employmentStatusData);
          // this.PreviousHealthCareExperienceData = this.sortNameValuePairData(response.previousHealthCareExperienceData);
          this.EthnicityData = response.ethnicityData;
          this.DegreeAwardedData = response.degreeAwardedData;
          this.AgeData = response.ageData;
          this.GenderData = response.genderData;
          this.GPAData = response.gpaData;
          this.PreviousDegreeData = response.previousDegreeData;
          this.UnitData = response.unitData;
          this.TerminationReasonData = response.terminationReasonData;
          //LPNLVNEmploymentStatus
          this.EmploymentStatusData = response.employmentStatusData;
          this.PreviousHealthCareExperienceData = response.previousHealthCareExperienceData;
          //console.log(`this.SystemData`, this.SystemData);
          this.loadPageState();
        }

      });
  }

  sortNameValuePairData(list: NameValuePair[], orderByDesc = false): NameValuePair[] {
    // sorts organizations alphabetically
    list.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (!orderByDesc) {
        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        }
      }
      else {
        if (nameA < nameB) {
          return 1;
        }

        if (nameA > nameB) {
          return -1;
        }
      }

      return 0;
    });

    return list;
  }

  private getTime(date?: Date) {
    return date != null ? new Date(date).getTime() : 0;
  }

  public sortDate(array: NameValuePair[]): NameValuePair[] {
    return array.sort((a: NameValuePair, b: NameValuePair) => {
      return this.getTime(new Date(b.name)) - this.getTime(new Date(a.name));
    });
  }

  loadFilters() {

    console.log('load filters start')

    this.getSystemAndOrgsList();
    this.getCohortsFromOrg();
    this.getFilterConfigData();
    

      this.CompareGroupData = [
        { name: 'All NRP Participants', value: 'All NRP Participants' }
      ];
      console.log('load filters end')

  }

  async exportToPDF() {

    await this.pbiReport.print();

  }

  async mobileLayout() {
    let pages = await this.pbiReport.getPages();
    let mobileLayout = await pages[0].hasLayout(pbi.models.LayoutType.MobilePortrait);
    console.log(`mobileLayout`, mobileLayout);
    const newSettings = {
      layoutType: mobileLayout ? pbi.models.LayoutType.Master : pbi.models.LayoutType.MobileLandscape
    };
    console.log(`newSettings`, newSettings);
    await this.pbiReport.updateSettings(newSettings);
    await this.pbiReport.reload();

  }
  toggleFilters() {
    this.showFilterPane = !this.showFilterPane;
  }
  async gotoFirstPage() {
    let pages = await this.pbiReport.getPages();
    let log = "Report pages:";
    if (!pages)
      return;
    //console.log(pages);
    await this.firstPage.setActive();
  }

}
